import {
  PROJECT_DISCIPLINES,
  isEstimationProjectType,
  projectTypeDiscipline,
} from "../../../../../constants/projectTypes";

// WBS under a plant are shown grouped by discipline rather than as one flat
// list, so a plant with dozens of them stays readable. The disciplines and
// their order come from PROJECT_DISCIPLINES so the tree can't drift from the
// type picker; anything with an unrecognised (or missing) `type` falls into
// "Other" instead of vanishing.
//
// Groups carry the discipline's own name - "Pressure Vessel", "Piping" -
// rather than its type code ("PVE", "PIE"). The codes are what a WBS is
// SAVED as and nothing here changes that: this is the folder's label alone.
export const WBS_GROUPS = [
  ...PROJECT_DISCIPLINES.map((discipline) => ({ ...discipline })),
  { key: "other", label: "Other" },
];

export const wbsGroupKey = (wbs) => projectTypeDiscipline(wbs?.type) || "other";

// Deliberately not prefixed "plant-"/"wbs-": handleNodeToggle keys the WBS
// and document fetches off those prefixes, and a group folder has nothing
// of its own to load.
export const wbsGroupNodeId = (plantId, groupKey) =>
  `grp-${plantId}-${groupKey}`;

// Discipline folders under "Projects" that list only Estimation-type WBS.
const ESTIMATION_ONLY_GROUPS = ["pv", "pip", "struc"];

/**
 * The folder a WBS sits in under "Projects". Pressure Vessel, Piping and
 * Structural list only Estimation WBS (PVE / PIE / STE); legacy "pv" / "pip" /
 * "struc" records count as "other" rather than sitting beside them as
 * look-alike duplicates.
 */
export const treeGroupKey = (wbs) => {
  const key = wbsGroupKey(wbs);
  if (
    ESTIMATION_ONLY_GROUPS.includes(key) &&
    !isEstimationProjectType(wbs?.type)
  ) {
    return "other";
  }
  return key;
};

/**
 * "other" WBS - legacy and unrecognised types ("pv", "pip", "struc", "ga", …)
 * the website no longer creates. The tree doesn't list them at all.
 */
export const isSoftwareWbs = (wbs) => treeGroupKey(wbs) === "other";
